import React from 'react';
import withRouter from '../../lib/router/withRouter';

import PageTemplate from '../../components/template/PageTemplate';
import ProductDetailWrap from '../../views/product/detail/ProductDetailWrap';
import useToastMsg from '../../hooks/common/useToastMsg';
import useProductCopy from '../../hooks/queries/product/useProductCopy';
import { INIT_PRODUCT_DETAIL_MODEL } from '../../store/modules/product/models';
import productToastMsg from '../../constants/service/toastMsg/productToastMsg';
import { PRODUCT_DETAIL_PAGE_TYPE, PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';
import { extractErrorMessage } from '../../lib/utils/checkErrorResponse';

const ProductCopy = ({ match }) => {
  const toastMsg = useToastMsg();
  const { data } = useProductCopy(match.params.id, {
    initialData: INIT_PRODUCT_DETAIL_MODEL,
    onSuccess: () => {
      toastMsg.success(productToastMsg.GET_PRODUCT_COPY_INFO_REQUEST_SUCCESS);
    },
    onError: (error) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });

  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_COPY}>
      <ProductDetailWrap pageType={PRODUCT_DETAIL_PAGE_TYPE.COPY} data={data} />
    </PageTemplate>
  );
};

export default withRouter(ProductCopy);
